module.exports = "<a href=\"javascript:void(0)\"\n  class=\"g-admin-acordion-list-header\"\n  (click)=\"oToggle.emit()\">\n  <ng-content></ng-content>\n</a>\n"